

import { Alert } from 'antd';
import React, { useCallback, useEffect,useState } from 'react';

const WarningMessage = ({ msg, onClose }) => {
  const [message, setMessage] = useState(null);
  useEffect(() => {
    if (msg) {
      setMessage(msg)
    }
  }, [msg])
  const closeErrorMessage = useCallback(() => {
    setMessage(null);
    if (onClose) {
      onClose();
    }
  },[])
  return (
    <div className='mb-4'>
      {message && <Alert
        className="w-100 mb-4 banks-errmsg"
        type="warning"
        description={message}
        closable
        showIcon 
        onClose={closeErrorMessage}
      />}
    </div>
  );
};
export default WarningMessage;

